import React, { FC, useContext } from "react";
import { Grid, Theme, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { enums, interfaces, types } from "../../typescript";
import Hyperlink from "../Common/Hyperlink";
import { usePermissions } from "../../hooks";
import { VisibilityContext } from "../../context";

const useStyles = makeStyles((theme: Theme) => ({
  section: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    textAlign: "left",
  },
  header: {
    marginRight: "12px",

    "& > p": {
      fontWeight: 700,
    },
  },
  linkContainer: {
    display: "inherit",
  },
  link: {
    overflowWrap: "break-word",
    textDecorationLine: "none",
    color: "blue",
    cursor: "pointer",

    "&:hover": {
      color: theme.palette.primary.dark,
    },
  },
  text: {
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "flex-start",
    alignContent: "flex-start",
  },
  semicolon: {
    marginRight: "4px",
  },
}));

interface PanelSectionProps {
  header: string;
  items?: (interfaces.data.OtherTag | enums.data.FDADesignations)[] | string[] | React.ReactElement[];
  links?: interfaces.data.RxStrategy[];
  permissions?: types.data.Permissions;
}

const PanelSection: FC<PanelSectionProps> = ({ header, items, links, permissions }) => {
  const classes = useStyles();

  const hasPermission = usePermissions(permissions);

  const [visibilityContext, setVisibilityContext] = useContext(VisibilityContext);

  const handleClick = () => {
    setVisibilityContext({
      ...visibilityContext,
      marketing: true,
    });
  };

  const renderedItems = [...(items ?? [])].map((x, i) => (
    <>
      {typeof x === "string" ? <>{x}</> : x}
      {i < items!.length - 1 ? "; " : ""}
    </>
  ));
  return (
    <Grid item xs={12} className={classes.section}>
      <div className={classes.header}>
        <Typography variant="body2">{header}</Typography>
      </div>
      <div className={classes.text}>
        {links
          ? links.map((rxStrategy, i) => {
              return hasPermission ? (
                <span key={i} className={classes.linkContainer}>
                  <Hyperlink url={rxStrategy.url}>
                    <Typography variant="body2">{rxStrategy.clinicalDevelopmentNotes}</Typography>
                  </Hyperlink>
                  <span className={classes.semicolon}>{`${links.length === i + 1 ? "" : ";"}`}</span>
                </span>
              ) : (
                <span key={i} className={classes.linkContainer} onClick={() => handleClick()}>
                  <a href="#" className={classes.link}>
                    <Typography variant="body2">{rxStrategy.clinicalDevelopmentNotes}</Typography>
                  </a>
                  <span className={classes.semicolon}>{`${links.length === i + 1 ? "" : ";"}`}</span>
                </span>
              );
            })
          : items && <>{items && <Typography variant="body2">{renderedItems}</Typography>}</>}
      </div>
    </Grid>
  );
};

export default PanelSection;
